import React from "react";

interface ProfileSectionFrameProps {
  title: string;
  /** One line in plain words under the title. */
  hint: string;
  /** The section's main button; it sits right of the title, and under it on a narrow screen. */
  action?: React.ReactNode;
  children: React.ReactNode;
}

/** The same top of every cabinet section: name, one line about it, main button. */
export default function ProfileSectionFrame({
  title,
  hint,
  action,
  children,
}: ProfileSectionFrameProps) {
  return (
    <div className="w-full px-4 py-6 lg:px-8">
      <header className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">{title}</h1>
          <p className="mt-1 text-sm text-gray-600">{hint}</p>
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </header>
      {children}
    </div>
  );
}
